module.exports = __webpack_public_path__ + "static/media/feedback-3.c76f079a.png";